import { Injectable } from '@angular/core';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { SonidosalertaProvider } from '../sonidosalerta/sonidosalerta';
import { TipoSonidoEvento } from '../../models/ajustes-data.model';
import { AlertController, Platform } from '@ionic/angular';
import { AuthProvider } from 'src/app/services/shared/autorizacion';
import { HttpApiProvider } from 'src/app/services/http-api/http-api';
import { AjustesProvider } from 'src/app/services/ajustes/ajustes';
import { Observable } from 'rxjs';
import { NetworkConnectionModel } from 'src/app/models/NetworkConnectionModel/NetworkConnection';
/*
  Generated class for the NetworkestatusProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
  providedIn: 'root'
})
export class NetworkestatusProvider {
  public blnIsConnect = false;
  public strType = '';

  private alert: any;

  constructor(
    private network: Network,
    private alertCtrl: AlertController,
    private platform: Platform,
    private sonidosalertaProvider: SonidosalertaProvider,
    private authService: AuthProvider,
    private httpApiService: HttpApiProvider,
    private ajustesProvider: AjustesProvider,
  ) {

    this.initAlert();

    console.log('Hello NetworkestatusProvider Provider');
    this.sonidosalertaProvider.initSounds();
  }

  async initAlert() {
    this.alert = await this.alertCtrl.create({
      header: 'Perdimos la conexión a internet =(',
      subHeader: 'Favor de validar la conexión o contacte al departamento de infraestructura',
      backdropDismiss: false
    });
  }

  iniciarEstatusDeConeccion() {
    console.log('network iniciarEstatusDeConeccion!');

    this.network.onConnect().subscribe(data => {
      console.log('network connected!');
      console.log(data);
      this.blnIsConnect = true;
      this.strType = this.network.type;
    });

    this.network.onDisconnect().subscribe(data => {
      console.log('network Disconnect =(');
      console.log(data);
      this.blnIsConnect = false;
      this.strType = '';
    });
  }

  iniciarEstatusDeConeccionConInterrupcion() {
    console.log('network iniciarEstatusDeConeccionConInterrupcion!');

    console.log('this.network', this.network);

    if (this.platform.is('cordova')) {
      this.network.onConnect().subscribe(data => {
        console.log('onConnect subscribe');

        this.blnIsConnect = true;
        this.strType = this.network.type;
        this.sonidosalertaProvider.playsound(TipoSonidoEvento.MensajeCorrectoConeccion);

        this.alert.diss();

        this.alert = this.alertCtrl.create({
          header: 'Perdimos la conexión a internet =(',
          subHeader: 'Favor de validar la conexión o contacte al departamento de infraestructura',
          backdropDismiss: false
        });
      });

      this.network.onDisconnect().subscribe(data => {
        console.log('onDisconnect subscribe');

        this.blnIsConnect = false;
        this.strType = '';

        this.sonidosalertaProvider.playsound(TipoSonidoEvento.MensajeErrorConeccion);
        this.alert.present();
      });
    } else {
      window.addEventListener('offline', (e: Event) => {
        this.onStatusChange(e, this);
      });
      window.addEventListener('online', (e: Event) => {
        this.onStatusChange(e, this);
      });
    }
  }

  onStatusChange(evt, that) {
    console.log('evt', evt);

    if (evt.type === 'offline') {
      that.sonidosalertaProvider.playsound(TipoSonidoEvento.MensajeErrorConeccion);
      that.alert.present();
    } else if (evt.type === 'online') {
      that.sonidosalertaProvider.playsound(TipoSonidoEvento.MensajeCorrectoConeccion);

      that.alert.dismiss();

      that.alert = that.alertCtrl.create({
        title: 'Perdimos la conexión a internet =(',
        subTitle: 'Favor de validar la conexión o contacte al departamento de infraestructura',
        enableBackdropDismiss: false
      });
    }
  }

  public saveBitacoraNetworkConnection(NetworlabelAnswerkConnection: NetworkConnectionModel): Observable<boolean> {
    if (this.authService.passCard.tokenData) {
      const strPredicado = `NetworkConnection/InsertarBitacoraNetworkConnection?tokenData=${this.authService.passCard.tokenData}`;
      return this.httpApiService.ejecutarPostQuery(this.ajustesProvider.ajustes.wmsApiOperacionUrl, strPredicado, NetworlabelAnswerkConnection);
    }
  }
}
